(function() {
  'use strict';

  if (window.NikuyaPDP02Registered) {
    return;
  }

  window.NikuyaPDP02Registered = true;

  var selectors = {
    track: '[data-nikuya-pdp-02-track]',
    card: '[data-nikuya-pdp-02-card]',
    video: '[data-nikuya-pdp-02-video]',
    play: '[data-nikuya-pdp-02-play]',
    dot: '[data-nikuya-pdp-02-dot]',
    arrows: '[data-nikuya-pdp-02-arrows]',
    previous: '[data-nikuya-pdp-02-previous]',
    next: '[data-nikuya-pdp-02-next]'
  };
  var registeredVideos = new Set();

  function setPlayButtonPresentation(video, state) {
    var card = video && video.closest(selectors.card);
    var playButton = card && card.querySelector(selectors.play);

    if (!playButton) {
      return;
    }

    if (!playButton.dataset.idleLabel) {
      playButton.dataset.idleLabel = playButton.getAttribute('aria-label') || '';
    }

    if (state === 'manual') {
      playButton.tabIndex = -1;
      playButton.setAttribute('aria-hidden', 'true');
      return;
    }

    playButton.tabIndex = 0;
    playButton.removeAttribute('aria-hidden');
    playButton.setAttribute(
      'aria-label',
      state === 'autoplay' && playButton.dataset.controlsLabel ?
        playButton.dataset.controlsLabel :
        playButton.dataset.idleLabel
    );
  }

  function enterVideoPresentation(video, interactive) {
    if (!video) {
      return;
    }

    video.controls = Boolean(interactive);
    video.tabIndex = interactive ? 0 : -1;
    if (interactive) {
      video.removeAttribute('aria-hidden');
    } else {
      video.setAttribute('aria-hidden', 'true');
    }
  }

  function resetVideoPresentation(video) {
    var card = video && video.closest(selectors.card);
    var playButton = card && card.querySelector(selectors.play);
    var videoHadFocus = video && document.activeElement === video;

    if (card) {
      card.classList.remove('is-playing', 'is-media-active');
    }
    if (video) {
      video.controls = false;
      video.tabIndex = -1;
      video.setAttribute('aria-hidden', 'true');
      video.removeAttribute('data-automatic');
      video.removeAttribute('data-user-activated');
      setPlayButtonPresentation(video, 'idle');
      if (videoHadFocus) {
        if (playButton && typeof playButton.focus === 'function') {
          playButton.focus({preventScroll: true});
        } else if (typeof video.blur === 'function') {
          video.blur();
        }
      }
    }
  }

  function promoteVideoPresentation(video, moveFocus) {
    var card = video && video.closest(selectors.card);

    if (!video || !card) {
      return;
    }

    video.dataset.userActivated = 'true';
    video.dataset.automatic = 'false';
    enterVideoPresentation(video, true);
    if (moveFocus && typeof video.focus === 'function') {
      video.focus({preventScroll: true});
    }
    card.classList.add('is-media-active');
    setPlayButtonPresentation(video, 'manual');
  }

  function pauseRegisteredVideos(exception) {
    registeredVideos.forEach(function(video) {
      if (video !== exception && typeof video.pause === 'function') {
        video.pause();
        resetVideoPresentation(video);
      }
    });
  }

  function NikuyaPDP02(container) {
    this.container = container;
    this.track = container.querySelector(selectors.track);
    this.cards = Array.prototype.slice.call(container.querySelectorAll(selectors.card));
    this.cardVideos = this.cards.map(function(card) {
      return card.querySelector(selectors.video);
    });
    this.videos = this.cardVideos.filter(function(video) {
      return Boolean(video);
    });
    this.dots = Array.prototype.slice.call(container.querySelectorAll(selectors.dot));
    this.arrows = container.querySelector(selectors.arrows);
    this.previousButton = container.querySelector(selectors.previous);
    this.nextButton = container.querySelector(selectors.next);
    this.abortController = new AbortController();
    this.signal = this.abortController.signal;
    this.activeIndex = 0;
    this.sectionInView = false;
    this.scrollFrame = null;
    this.navigationCheckFrame = null;
    this.navigationSettleTimer = null;
    this.navigationTarget = null;
    this.navigationRequestId = 0;
    this.resizeObserver = null;
    this.sectionObserver = null;
    this.mobileQuery = window.matchMedia('(max-width: 767px)');
    this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.saveData = Boolean(navigator.connection && navigator.connection.saveData);

    if (!this.track || !this.cards.length) {
      return;
    }

    this.videos.forEach(function(video) {
      registeredVideos.add(video);
      resetVideoPresentation(video);
    });
    this.bindEvents();
    this.observeSection();
    this.observeSize();
    this.updateActiveState();
    this.updateArrowState();
  }

  NikuyaPDP02.prototype = Object.assign({}, NikuyaPDP02.prototype, {
    bindEvents: function() {
      this.track.addEventListener('scroll', this.onTrackScroll.bind(this), {passive: true, signal: this.signal});
      this.track.addEventListener('scrollend', this.onTrackScrollEnd.bind(this), {signal: this.signal});
      this.track.addEventListener('pointerdown', this.onNavigationInterrupt.bind(this), {passive: true, signal: this.signal});
      this.track.addEventListener('wheel', this.onNavigationInterrupt.bind(this), {passive: true, signal: this.signal});
      this.track.addEventListener('keydown', this.onNavigationInterrupt.bind(this), {signal: this.signal});
      document.addEventListener('visibilitychange', this.onVisibilityChange.bind(this), {signal: this.signal});

      this.cards.forEach(function(card, index) {
        var playButton = card.querySelector(selectors.play);
        var video = card.querySelector(selectors.video);

        if (playButton && video) {
          playButton.addEventListener('click', function() {
            this.activateCard(index, false);
            if (video.paused || video.ended) {
              this.playVideo(video, false);
            }
            promoteVideoPresentation(video, true);
          }.bind(this), {signal: this.signal});
        }

        if (video) {
          video.addEventListener('pointerdown', function() {
            promoteVideoPresentation(video, false);
          }, {passive: true, signal: this.signal});
          video.addEventListener('keydown', function() {
            promoteVideoPresentation(video, false);
          }, {signal: this.signal});
          video.addEventListener('play', function() {
            this.cancelProgrammaticNavigation();
            pauseRegisteredVideos(video);
            this.activeIndex = index;
            if (video.dataset.automatic !== 'true') {
              video.dataset.userActivated = 'true';
            }
            enterVideoPresentation(video, video.dataset.userActivated === 'true');
            this.updateActiveState();
          }.bind(this), {signal: this.signal});
          video.addEventListener('playing', function() {
            if (video.dataset.userActivated === 'true') {
              card.classList.add('is-media-active');
              setPlayButtonPresentation(video, 'manual');
            } else {
              setPlayButtonPresentation(video, 'autoplay');
            }
            card.classList.add('is-playing');
          }, {signal: this.signal});
          video.addEventListener('pause', function() {
            if (video.paused) {
              card.classList.remove('is-playing');
            }
          }, {signal: this.signal});
          video.addEventListener('ended', function() {
            resetVideoPresentation(video);
          }, {signal: this.signal});
        }
      }.bind(this));

      this.dots.forEach(function(dot, index) {
        dot.addEventListener('click', function() {
          this.activateCard(index, true);
        }.bind(this), {signal: this.signal});
      }.bind(this));

      if (this.previousButton) {
        this.previousButton.addEventListener('click', function() {
          this.moveByCard(-1);
        }.bind(this), {signal: this.signal});
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', function() {
          this.moveByCard(1);
        }.bind(this), {signal: this.signal});
      }

      if (this.reducedMotionQuery.addEventListener) {
        this.reducedMotionQuery.addEventListener('change', this.onMotionPreferenceChange.bind(this), {signal: this.signal});
      } else {
        this.legacyMotionListener = this.onMotionPreferenceChange.bind(this);
        this.reducedMotionQuery.addListener(this.legacyMotionListener);
      }
    },

    observeSection: function() {
      if (!('IntersectionObserver' in window)) {
        this.sectionInView = true;
        this.autoplayActiveVideo();
        return;
      }

      this.sectionObserver = new IntersectionObserver(function(entries) {
        var entry = entries[0];
        this.sectionInView = Boolean(entry && entry.isIntersecting && entry.intersectionRatio >= 0.35);

        if (this.sectionInView) {
          this.autoplayActiveVideo();
        } else {
          this.pauseAll();
        }
      }.bind(this), {threshold: [0, 0.35, 0.6]});

      this.sectionObserver.observe(this.container);
    },

    observeSize: function() {
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(function() {
          this.updateArrowState();
        }.bind(this));
        this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', this.updateArrowState.bind(this), {signal: this.signal});
      }
    },

    onTrackScroll: function() {
      if (this.scrollFrame) {
        window.cancelAnimationFrame(this.scrollFrame);
      }

      this.scrollFrame = window.requestAnimationFrame(function() {
        if (this.navigationTarget === null) {
          this.updateActiveFromPosition();
        } else {
          this.scheduleNavigationSettlement(this.navigationRequestId);
        }
        this.updateArrowState();
        this.scrollFrame = null;
      }.bind(this));
    },

    onTrackScrollEnd: function() {
      var requestId = this.navigationRequestId;
      var targetIndex = this.navigationTarget;

      if (targetIndex !== null && this.isNavigationTargetSettled(targetIndex)) {
        this.finishProgrammaticNavigation(requestId);
      }
    },

    onNavigationInterrupt: function() {
      if (this.navigationTarget === null) {
        return;
      }

      this.cancelProgrammaticNavigation();
      this.updateArrowState();
    },

    scheduleNavigationSettlement: function(requestId) {
      if (this.navigationTarget === null || requestId !== this.navigationRequestId) {
        return;
      }

      if (this.navigationSettleTimer) {
        window.clearTimeout(this.navigationSettleTimer);
      }
      var settleTimer = window.setTimeout(function() {
        if (this.navigationSettleTimer === settleTimer) {
          this.navigationSettleTimer = null;
        }
        if (requestId !== this.navigationRequestId) {
          return;
        }
        this.finishProgrammaticNavigation(requestId);
      }.bind(this), 120);
      this.navigationSettleTimer = settleTimer;
    },

    cancelProgrammaticNavigation: function() {
      this.navigationRequestId += 1;
      this.navigationTarget = null;

      if (this.navigationSettleTimer) {
        window.clearTimeout(this.navigationSettleTimer);
        this.navigationSettleTimer = null;
      }
      if (this.navigationCheckFrame) {
        window.cancelAnimationFrame(this.navigationCheckFrame);
        this.navigationCheckFrame = null;
      }
    },

    finishProgrammaticNavigation: function(requestId) {
      if (requestId !== this.navigationRequestId) {
        return;
      }

      var targetIndex = this.navigationTarget;

      this.cancelProgrammaticNavigation();
      if (targetIndex === null || !this.cards[targetIndex]) {
        this.updateActiveFromPosition();
        return;
      }

      this.activeIndex = targetIndex;
      this.pauseAll(this.cardVideos[targetIndex]);
      this.updateActiveState();
      this.updateArrowState();
      this.autoplayActiveVideo();
    },

    getNearestCardIndex: function() {
      var trackRect = this.track.getBoundingClientRect();
      var mobile = this.mobileQuery.matches;
      var referencePoint = mobile ? trackRect.left + (trackRect.width / 2) : trackRect.left;
      var candidateDistance = Infinity;
      var candidateIndex = this.activeIndex;

      this.cards.forEach(function(card, index) {
        var rect = card.getBoundingClientRect();
        var cardPoint = mobile ? rect.left + (rect.width / 2) : rect.left;
        var distance = Math.abs(cardPoint - referencePoint);

        if (distance < candidateDistance) {
          candidateDistance = distance;
          candidateIndex = index;
        }
      });

      return candidateIndex;
    },

    isNavigationTargetSettled: function(index) {
      var card = this.cards[index];

      if (!card) {
        return false;
      }

      var trackRect = this.track.getBoundingClientRect();
      var cardRect = card.getBoundingClientRect();
      var maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      var centeredPosition = this.track.scrollLeft + cardRect.left - trackRect.left -
        ((trackRect.width - cardRect.width) / 2);
      var targetPosition = Math.max(0, Math.min(maximum, centeredPosition));

      return Math.abs(this.track.scrollLeft - targetPosition) <= 2;
    },

    updateActiveFromPosition: function() {
      if (!this.cards.length) {
        return;
      }

      var trackRect = this.track.getBoundingClientRect();
      var mobile = this.mobileQuery.matches;
      var referencePoint = mobile ? trackRect.left + (trackRect.width / 2) : trackRect.left;
      var currentDistance = Infinity;
      var candidateDistance = Infinity;
      var candidateIndex = this.activeIndex;

      this.cards.forEach(function(card, index) {
        var rect = card.getBoundingClientRect();
        var cardPoint = mobile ? rect.left + (rect.width / 2) : rect.left;
        var distance = Math.abs(cardPoint - referencePoint);

        if (index === this.activeIndex) {
          currentDistance = distance;
        }
        if (distance < candidateDistance) {
          candidateDistance = distance;
          candidateIndex = index;
        }
      }.bind(this));

      var hysteresis = (this.cards[candidateIndex].offsetWidth || 0) * 0.08;
      if (candidateIndex !== this.activeIndex && candidateDistance + hysteresis < currentDistance) {
        this.activeIndex = candidateIndex;
        this.pauseAll(this.cardVideos[candidateIndex]);
        this.updateActiveState();
        this.autoplayActiveVideo();
      }
    },

    activateCard: function(index, shouldScroll) {
      if (!this.cards[index]) {
        return;
      }

      var wasNavigating = this.navigationTarget !== null;
      this.cancelProgrammaticNavigation();

      if (index === this.activeIndex && !wasNavigating) {
        this.updateArrowState();
        return;
      }

      if (shouldScroll || wasNavigating && index === this.activeIndex) {
        var requestId = this.navigationRequestId;
        this.navigationTarget = index;
        this.pauseAll();
        this.updateArrowState();
        this.cards[index].scrollIntoView({
          behavior: this.reducedMotionQuery.matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center'
        });

        if (this.reducedMotionQuery.matches) {
          this.finishProgrammaticNavigation(requestId);
        } else {
          this.scheduleNavigationSettlement(requestId);
          var navigationCheckFrame = window.requestAnimationFrame(function() {
            if (this.navigationCheckFrame === navigationCheckFrame) {
              this.navigationCheckFrame = null;
            }
            if (
              requestId === this.navigationRequestId &&
              this.navigationTarget === index &&
              this.isNavigationTargetSettled(index)
            ) {
              this.finishProgrammaticNavigation(requestId);
            }
          }.bind(this));
          this.navigationCheckFrame = navigationCheckFrame;
        }
        return;
      }

      this.activeIndex = index;
      this.pauseAll(this.cardVideos[index]);
      this.updateActiveState();
    },

    moveByCard: function(direction) {
      var baseIndex = this.navigationTarget === null ? this.activeIndex : this.navigationTarget;
      var nextIndex = Math.max(0, Math.min(this.cards.length - 1, baseIndex + direction));
      this.activateCard(nextIndex, true);
    },

    updateActiveState: function() {
      this.cards.forEach(function(card, index) {
        card.classList.toggle('is-active', index === this.activeIndex);
      }.bind(this));

      this.dots.forEach(function(dot, index) {
        var active = index === this.activeIndex;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      }.bind(this));
    },

    updateArrowState: function() {
      if (!this.arrows || !this.previousButton || !this.nextButton) {
        return;
      }

      var maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      var hasOverflow = maximum > 2;
      var boundaryIndex = this.navigationTarget === null ? this.activeIndex : this.navigationTarget;
      this.arrows.hidden = !hasOverflow;
      this.previousButton.disabled = !hasOverflow || boundaryIndex <= 0;
      this.nextButton.disabled = !hasOverflow || boundaryIndex >= this.cards.length - 1;
    },

    canAutoplay: function() {
      return this.sectionInView &&
        !this.reducedMotionQuery.matches &&
        !this.saveData &&
        document.visibilityState !== 'hidden';
    },

    autoplayActiveVideo: function() {
      if (!this.canAutoplay()) {
        return;
      }

      var video = this.cardVideos[this.activeIndex];
      if (video) {
        this.playVideo(video, true);
      }
    },

    loadVideo: function(video) {
      if (!video || video.dataset.loaded === 'true') {
        return;
      }

      Array.prototype.forEach.call(video.querySelectorAll('source[data-src]'), function(source) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.dataset.loaded = 'true';
      video.load();
    },

    playVideo: function(video, automatic) {
      if (!video || automatic && !this.canAutoplay()) {
        return;
      }
      if (automatic && video.dataset.userActivated === 'true') {
        return;
      }

      pauseRegisteredVideos(video);
      this.loadVideo(video);
      video.dataset.automatic = automatic ? 'true' : 'false';
      if (automatic) {
        video.muted = true;
      }
      enterVideoPresentation(video, !automatic);

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function() {
          resetVideoPresentation(video);
        });
      }
    },

    pauseAll: function(exception) {
      this.videos.forEach(function(video) {
        if (video !== exception && typeof video.pause === 'function') {
          video.pause();
          resetVideoPresentation(video);
        }
      });
    },

    onVisibilityChange: function() {
      if (document.visibilityState === 'hidden') {
        this.pauseAll();
      } else {
        this.autoplayActiveVideo();
      }
    },

    onMotionPreferenceChange: function() {
      if (this.reducedMotionQuery.matches) {
        this.videos.forEach(function(video) {
          if (video.dataset.automatic === 'true') {
            video.pause();
            resetVideoPresentation(video);
          }
        });
      }
    },

    onBlockSelect: function(evt) {
      var blockId = evt && evt.detail && evt.detail.blockId;
      var eventTarget = evt && evt.target;
      var selectedCard = null;

      this.cards.some(function(card) {
        if (card.dataset.blockId === blockId || card === eventTarget || eventTarget && card.contains(eventTarget)) {
          selectedCard = card;
          return true;
        }
        return false;
      });

      var selectedIndex = this.cards.indexOf(selectedCard);
      if (selectedIndex >= 0) {
        this.activateCard(selectedIndex, true);
      }
    },

    onUnload: function() {
      this.abortController.abort();
      this.cancelProgrammaticNavigation();
      this.pauseAll();

      this.videos.forEach(function(video) {
        registeredVideos.delete(video);
      });

      if (this.scrollFrame) {
        window.cancelAnimationFrame(this.scrollFrame);
      }
      if (this.sectionObserver) {
        this.sectionObserver.disconnect();
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      if (this.legacyMotionListener) {
        this.reducedMotionQuery.removeListener(this.legacyMotionListener);
      }
    }
  });

  function registerSection() {
    if (!window.theme || !theme.sections) {
      return;
    }

    theme.sections.register('nikuya-pdp-02', NikuyaPDP02);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerSection, {once: true});
  } else {
    registerSection();
  }
})();
